module.exports = __webpack_public_path__ + "static/podcast6-9f378b6c39401846833da677a86db7e5.jpg";